import * as angular from "angular";
import {ModalWindowController} from "./modal-window.controller";
const templateUrl = require("./modal-window.html");

export const modalWindow: angular.IDirective = {
    templateUrl: templateUrl,
    controller: ModalWindowController,
    controllerAs: "vm",
    bindToController: true,
    scope: {}
};


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/common/modal-window/modal-window.ts
 **/